import React from 'react';
import { useInView } from 'react-intersection-observer';

function AnimateOnScroll({ children }) {
  const { ref, inView } = useInView({
    /* خيارات اختيارية */
    triggerOnce: true, // يجعل الأنيميشن يعمل مرة واحدة فقط
    threshold: 0.1,    // نسبة ظهور العنصر على الشاشة لتشغيل الأنيميشن
  });

  return (
    <div
      ref={ref}
      className={`animate-on-scroll ${inView ? 'is-visible' : ''}`}
    >
      {children}
    </div>
  );
}

export default AnimateOnScroll;